import { gql } from '@apollo/client'

export const getAllUsers = gql`
    query GetAllUsers($pageSize: Int, $page: Int, $rcUserId: String, $userName: String) {
        getAllUsers(pageSize: $pageSize, page: $page, rcUserId: $rcUserId, userName: $userName) {
            users {
                id
                createdAt
                updatedAt
                email
                role
                appleSub
                googleSub
                isAgreementChecked
                premiumExpiryDate
                fcmId
                rcUserId
                userName
                store
                isOrganic
                isPremium
            }
            totalCount
        }
    }
`

export const getUser = gql`
    query GetUser($userId: String!) {
        getUser(userId: $userId) {
            id
            createdAt
            updatedAt
            email
            role
            appleSub
            googleSub
            isAgreementChecked
            aiProcessingConsent
            photoUploadConsent
            premiumExpiryDate
            fcmId
            rcUserId
            store
            isOrganic
            totalRevenue
            totalCredit {
                total
                dailyCredit
            }
            moderations {
                total
                blackLists {
                    id
                    prompt
                    inputImg
                    type
                    category
                    userId
                    createdAt
                }
            }
      dailyStreak {
      id
      userId
      dayNumber
      creditsAwarded
      claimedDate
      claimedTimezoneOffset
      wasReset
      createdAt
      updatedAt
      creditId
    }
            usedCreditCount
            isPremium
        }
    }
`

export const getAllvideos = gql`
query GetAllVideos($status: StatusEnum, $model: ModelEnum, $rcUserId: String, $pageSize: Int, $page: Int, $startDate: DateTime, $endDate: DateTime, $type: String) {
  getAllVideos(status: $status, model: $model, rcUserId: $rcUserId, pageSize: $pageSize, page: $page, startDate: $startDate, endDate: $endDate, type: $type) {
    videos {
      id
      createdAt
      updatedAt
      model
      status
      prompt
      thumbnailUrl
      progressRatio
      type
      url
      flagged
    }
    totalCount
  }
}
`
export const getVideo = gql`
    query GetVideoDetail($videoId: String!) {
        getVideoDetail(videoId: $videoId) {
            id
            createdAt
            updatedAt
            jobId
            userId
            model
            modelName
            url
            status
            prompt
            category
            thumbnailUrl
            title
            motionScore
            style
            progressRatio
            aspectRatio
            upScale
            inputImageUrl
            errorReason
            seconds
            resolution
            ratioKey
            resolutionKey
            durationKey
            creditCost
            actualCost
            flagged
            tool {
                id
                name
            }
            feed {
                id
                status
            }
        }
    }
`

export const getAllCreditsAdmin = gql`
    query getAllCreditsAdmin {
        getAllCredits {
            amount
            rcEventId
            id
            user {
                id
                email
            }
            date
        }
    }
`
export const getHomePageVideos = gql`
    query GetHomePageVideos {
        getHomePageVideos {
            category
            createdAt
            id
            motionScore
            progressRatio
            prompt
            status
            style
            taskId
            thumbnailUrl
            title
            updatedAt
            url
        }
    }
`
export const getAllStyles = gql`
    query GetAllStyles {
        getAllStyles {
            banner
            createdAt
            id
            name
            updatedAt
            value
        }
    }
`
export const getExplorePage = gql`
    query GetAdminExplores($page: Float, $pageSize: Float) {
        getAdminExplores(page: $page, pageSize: $pageSize) {
            aspectRatio
            createdAt
            id
            motionScore
            prompt
            style
            thumbnailUrl
            updatedAt
            gif
            isHidden
            categoryId
            url
        }
    }
`
export const getExploreVideo = gql`
    query GetExploreVideo($exploreId: String!) {
        getExploreVideo(exploreId: $exploreId) {
            id
            url
            prompt
            thumbnailUrl
            motionScore
            style
            webmUrl
            region
            createdAt
            updatedAt
            aspectRatio
            lowResolutionUrl
            gif
            webmUrl
            exRegion
            categoryId
        }
    }
`
export const getUserCreditHistory = gql`
    query GetUserCreditHistory($userId: String!) {
        getUserCreditHistory(userId: $userId) {
            id
            userId
            creditId
            amount
            transactionId
            createdAt
            updatedAt
        }
    }
`
export const dashboardUserVideos = gql`
    query DashboardUserVideos($userId: String!) {
        dashboardUserVideos(userId: $userId) {
            id
            createdAt
            updatedAt
            taskId
            url
            status
            prompt
            category
            thumbnailUrl
            progressRatio
            aspectRatio
            upScale
            title
            motionScore
            style
        }
    }
`
export const dashboardUserImages = gql`
    query DashboardUserImages($userId: String!) {
        dashboardUserImages(userId: $userId) {
            id
            createdAt
            updatedAt
            model
            modelName
            status
            prompt
            url
            type
            aspectRatio
        }
    }
`
export const getDashboardData = gql`
    query DashboardData {
        dashboardData {
            totalVideo
            totalUser
            pieChartData {
                failed
                running
                in_queue
                throttled
                succeeded
                pending
            }
            lastCreatedVideoData
            dailyVideoCount {
                date
                count
            }
            activeSubscriptions
        }
    }
`
export const getCategories = gql`
query GetCategories($pageSize: Int, $page: Int) {
  getCategories(pageSize: $pageSize, page: $page) {
    id
    name
    description
    rowNumber
  }
}
`
export const getCategoriesAdmin = gql`
query GetCategoriesAdmin {
  getCategoriesAdmin {
    id
    name
    description
    rowNumber
    isHidden
    type
  }
}
`
export const getCategory = gql`
query GetCategory($categoryId: String!) {
  getCategory(categoryId: $categoryId) {
    id
    name
    description
    rowNumber
    createdAt
    updatedAt
    skipTranslation
    type
    tools {
      id
      name
      bannerUrl
      rowNumber
    }
  }
}
`
export const getSystem = gql`
    query GetSystem($systemType: SystemTypeEnum!) {
        getSystem(systemType: $systemType) {
            id
            provider
            type
            createdAt
            updatedAt
        }
    }
`
export const getAdminFeed = gql`
  query GetAdminFeed($pageSize: Int, $page: Int, $status: FeedStatus, $rcUserId: String, $aspectRatio: AspectRatioEnum, $feedId: String) {
    getAdminFeed(pageSize: $pageSize, page: $page, status: $status, rcUserId: $rcUserId, aspectRatio: $aspectRatio, feedId: $feedId) {
      feed {
        likeCount
        id
        status
        user {
          userName
        }
        video {
          thumbnailUrl
          id
          url
        }
        image {
          id
          url
        }
      }
      count
    }
  }
`;
export const getCredit = gql`
    query GetCredit($creditId: String!) {
        getCredit(creditId: $creditId) {
            id
            createdAt
            updatedAt
            date
            amount
            rcEventId
            productName
            productType
            expiryDate
            transactionId
            isPromo
        }
    }
`
export const supportAdmin = gql`
    query SupportAdmin($rcUserId: String!) {
        supportAdmin(rcUserId: $rcUserId) {
            credits {
                id
                createdAt
                updatedAt
                date
                amount
                rcEventId
                productName
                productType
                expiryDate
                transactionId
                isPromo
            }
            user {
                id
                createdAt
                updatedAt
                email
                role
                appleSub
                googleSub
                userName
                isAgreementChecked
                premiumExpiryDate
                fcmId
                rcUserId
                store
                firstSeenLocation
                totalCredit {
                    total
                }
                usedCreditCount
                isPremium
                videos {
                    id
                    status
                }
                lastSeenLocation
            }
            videoAnalyticData {
                succeeded
                failed
                total
                refund
            }
        }
    }
`


export const GET_USER_BY_ID = gql`
  query GetUserById($id: ID!) {
    user(id: $id) {
      id
      name
      email
      username
      phone
      address
      status
      createdAt
    }
  }
`;


export const getCreditStats = gql`
  query GetCreditStats($endDate: String, $startDate: String) {
  getCreditStats(endDate: $endDate, startDate: $startDate) {
    date
    creditCounts {
      weekly
      monthly
      yearly
      tier1
      tier2
      tier3
      oneTime
    }
    totalCount
  }
}
`;
export const getBasicStats = gql`
query GetBasicStats {
    getBasicStats {
      totalUsers
      totalVideos
      activeSubscriptions
      lastVideoDate
    }
  }
`;

export const getDailyVideoStats = gql`
query GetDailyVideoStats($endDate: String, $startDate: String) {
    getDailyVideoStats(endDate: $endDate, startDate: $startDate) {
      date
      count
    }
  }
`;

export const getVideoStatusStats = gql`
query GetVideoStatusStats($endDate: String, $startDate: String) {
    getVideoStatusStats(endDate: $endDate, startDate: $startDate) {
      failed
      running
      in_queue
      throttled
      succeeded
      pending
    }
  }
`;

export const getVideoTypeStats = gql`
query GetVideoTypeStats($endDate: String, $startDate: String, $status: StatusEnum) {
    getVideoTypeStats(endDate: $endDate, startDate: $startDate, status: $status) {
      img2Video
      text2Video
      toolPredict
      storyBoard
      generationWithAudio
      generationWithAudioFromImage
      generationWithAudioFromText
      editTool
      credit
      creditV2
      edit
      total
    }
  }
`;

export const getVideoCostStats = gql`
  query GetVideoCostStats($startDate: String, $endDate: String) {
    getVideoCostStats(startDate: $startDate, endDate: $endDate) {
      toolVideoCount
      toolCreditsSpent
      normalVideoCount
      normalCreditsSpent
      totalVideoCount
      totalCreditsSpent
    }
  }
`;

export const getAllCreditProducts = gql`
  query GetAllCreditProducts($filter: CreditProductFilterInput, $pagination: CreditProductPaginationInput!) {
    getAllCreditProducts(filter: $filter, pagination: $pagination) {
      total
      hasMore
      items {
        id
        name
        amount
        startDate
        endDate
        limit
        price
        type
        createdAt
        updatedAt
        creditCount
        isActive
        isExpired
        isUpcoming
      }
    }
  }
`

export const getCreditProductById = gql`
  query GetCreditProductById($getCreditProductByIdId: String!) {
    getCreditProductById(id: $getCreditProductByIdId) {
      id
      name
      amount
      startDate
      endDate
      limit
      price
      type
      createdAt
      updatedAt
      creditCount
      isActive
      isExpired
      isUpcoming
      offerings {
        id
        presentedOfferingId
        amount
        createdAt
        updatedAt
      }
    }
  }
`

export const getAllTools = gql`
query GetAllTools($filter: StudioFilterInput, $page: Int, $pageSize: Int, $sortByVideoCount: SortOrder) {
  getAllTools(filter: $filter, page: $page, pageSize: $pageSize, sortByVideoCount: $sortByVideoCount) {
    tools {
      id
      name
      imageType
      bannerUrl
      videoUrl
      lowResolutionUrl
      webmUrl
      webpUrl
      rowNumber
      templateId
      description
      prompt
      isFeatured
      isHidden
      duration
      model
      categoryId
      cost
      actualCost
      provider
      createdAt
      updatedAt
      videoCount
      type
      keywords
      aspectRatios {
        id
        width
        height
        name
        aspectRatioX
        aspectRatioY
        createdAt
        updatedAt
        toolId
      }
    }
    count
  }
}
`

export const getTool = gql`
query GetTool($getToolId: String!) {
  getTool(id: $getToolId) {
    id
    name
    imageType
    skipTranslation
    bannerUrl
    videoUrl
    lowResolutionUrl
    rowNumber
    templateId
    description
    prompt
    isFeatured
    isHidden
    duration
    categoryId
    cost
    actualCost
    provider
    createdAt
    updatedAt
    videoCount
    badgeText
    badgeIcon
    badgeTextColor
    badgeBackgroundColor
    type
    keywords
    category {
      id
      name
    }
    webmUrl
    webpUrl
    aspectRatios {
      id
      width
      height
      name
      aspectRatioX
      aspectRatioY
      createdAt
      updatedAt
      toolId
    }
  }
}
`

export const getCreditConfig = gql`
  query getModelList {
    getModelList
  }
`

export const getImageCreditConfig = gql`
  query getImageModelList {
    getImageModelList
  }
`

export const getModelListUnified = gql`
  query getModelListUnified {
    getModelListUnified
  }
`

export const getUnifiedMinVersion = gql`
  query getUnifiedMinVersion {
    getUnifiedMinVersion
  }
`

export const getModelListV2 = gql`
  query getModelListV2 {
    getModelListV2
  }
`

export const getModelListUnifiedV2 = gql`
  query getModelListUnifiedV2 {
    getModelListUnifiedV2
  }
`

export const getUnifiedV2MinVersion = gql`
  query getUnifiedV2MinVersion {
    getUnifiedV2MinVersion
  }
`

export const getModerationStatusMinVersion = gql`
  query getModerationStatusMinVersion {
    getModerationStatusMinVersion
  }
`

export const getCatalogueStandards = gql`
  query getCatalogueStandards {
    getCatalogueStandards
  }
`

export const getImageModelListUnified = gql`
  query getImageModelListUnified {
    getImageModelListUnified
  }
`

export const getModelListImageUnifiedV2 = gql`
  query getModelListImageUnifiedV2 {
    getModelListImageUnifiedV2
  }
`

export const getAllImages = gql`
query GetAllImages($status: StatusEnum, $model: ModelEnum, $rcUserId: String, $pageSize: Int, $page: Int, $startDate: DateTime, $endDate: DateTime, $type: String) {
  getAllImages(status: $status, model: $model, rcUserId: $rcUserId, pageSize: $pageSize, page: $page, startDate: $startDate, endDate: $endDate, type: $type) {
    images {
      id
      createdAt
      updatedAt
      model
      modelName
      status
      prompt
      url
      type
      aspectRatio
      flagged
    }
    totalCount
  }
}
`

export const getImage = gql`
  query GetImage($imageId: String!) {
    getImage(imageId: $imageId) {
      id
      createdAt
      updatedAt
      jobId
      userId
      model
      modelName
      url
      status
      prompt
      title
      aspectRatio
      inputImageUrl
      resolution
      ratioKey
      errorReason
      type
      flagged
      creditCost
      actualCost
      toolName
      toolId
      feed {
        id
        status
      }
    }
  }
`

export const getAdminNotifications = gql`
  query GetAdminNotifications($rcUserId: String, $page: Int, $pageSize: Int, $unreadOnly: Boolean, $type: String, $daysBack: Int) {
    getAdminNotifications(rcUserId: $rcUserId, page: $page, pageSize: $pageSize, unreadOnly: $unreadOnly, type: $type, daysBack: $daysBack) {
      notifications {
        id
        userId
        type
        title
        body
        data
        isRead
        sentAt
        readAt
        createdAt
        updatedAt
        user {
          id
          rcUserId
          email
        }
      }
      totalCount
    }
  }
`

export const getUserNotifications = gql`
  query GetUserNotifications($userId: String!, $skip: Int, $take: Int) {
    getUserNotifications(userId: $userId, skip: $skip, take: $take) {
      id
      userId
      type
      title
      body
      data
      isRead
      sentAt
      readAt
      createdAt
      updatedAt
    }
  }
`

export const getDailyToolUsage = gql`
  query GetDailyToolUsage($startDate: String!, $endDate: String!, $toolNames: [String!]) {
    getDailyToolUsage(startDate: $startDate, endDate: $endDate, toolNames: $toolNames) {
      date
      totalCount
      toolUsage {
        toolId
        toolName
        count
      }
    }
  }
`
export const getNotificationTitleStatAdmin = gql`
  query GetNotificationTitleStatAdmin($title: String!, $startDate: DateTime!, $endDate: DateTime!) {
    getNotificationTitleStatAdmin(title: $title, startDate: $startDate, endDate: $endDate) {
      title
      read
      unread
      total
    }
  }
`;
export const getNotificationTitlesAdmin = gql`
  query GetNotificationTitlesAdmin {
    getNotificationTitlesAdmin
  }
`;

export const getAppVersions = gql`
  query GetAppVersions($page: Int, $pageSize: Int) {
    getAppVersions(page: $page, pageSize: $pageSize) {
      id
      version
      reviewMode
      createdAt
      updatedAt
    }
  }
`;

export const getAppVersion = gql`
  query GetAppVersion($appVersionId: String!) {
    getAppVersion(appVersionId: $appVersionId) {
      id
      version
      reviewMode
      createdAt
      updatedAt
    }
  }
`;

export const getAppVersionsCount = gql`
  query GetAppVersionsCount {
    getAppVersionsCount
  }
`;

export const listPricingConfigs = gql`
  query listPricingConfigs {
    listPricingConfigs {
      id
      proceedPerCredit
      costCap
      discount
      createdAt
    }
  }
`;

export const getAdminBanners = gql`
  query GetAdminBanners($page: Int, $pageSize: Int) {
    getAdminBanners(page: $page, pageSize: $pageSize) {
      banners {
        id
        name
        rowNumber
        isActive
        audienceType
        targetingRules
        startDate
        endDate
        createdAt
        updatedAt
        itemCount
      }
      count
    }
  }
`;

export const getAdminBanner = gql`
  query GetAdminBanner($id: String!) {
    getAdminBanner(id: $id) {
      id
      name
      rowNumber
      isActive
      audienceType
      targetingRules
      startDate
      endDate
      createdAt
      updatedAt
      items {
        id
        imageUrl
        videoUrl
        lowResolutionUrl
        actionType
        toolId
        promptText
        builderType
        generationMode
        builderConfig
        paywallType
        paywallId
        audienceType
        targetingRules
        sortOrder
        isActive
        createdAt
      }
    }
  }
`;


export const getRemoteConfigs = gql`
  query GetRemoteConfigs($page: Int, $pageSize: Int, $name: String) {
    getRemoteConfigs(page: $page, pageSize: $pageSize, name: $name) {
      id
      name
      createdAt
      updatedAt
      locales {
        id
        locale
        updatedAt
      }
    }
  }
`;

export const getRemoteConfigsCount = gql`
  query GetRemoteConfigsCount($name: String) {
    getRemoteConfigsCount(name: $name)
  }
`;

export const getRemoteConfig = gql`
  query GetRemoteConfig($id: String!) {
    getRemoteConfig(id: $id) {
      id
      name
      createdAt
      updatedAt
      locales {
        id
        locale
        content
        updatedAt
      }
    }
  }
`;

export const getGlobalReviewMode = gql`
  query GetGlobalReviewMode {
    getGlobalReviewMode
  }
`;

export const subscriberUsageStats = gql`
  query subscriberUsageStats($startDate: String!, $endDate: String!) {
    subscriberUsageStats(startDate: $startDate, endDate: $endDate) {
      subscriberCount
      totalGenerations
      per1KUsers
      typeBreakdown {
        txtToVideo
        imgToVideo
        videoTools
        textToImage
        imgToImg
        imageTools
      }
      dailyBreakdown {
        date
        count
      }
    }
  }
`;

export const getAdminTabs = gql`
  query GetAdminTabs {
    getAdminTabs {
      id
      name
      rowNumber
      isActive
      contentType
      additionMethod
      sortMode
      sortField
      sortDirection
      usageWindowDays
      typeFilter
      limit
      shuffleResults
      maxPerCategory
      createdAt
      updatedAt
    }
  }
`;

export const getAdminTab = gql`
  query GetAdminTab($id: String!) {
    getAdminTab(id: $id) {
      id
      name
      rowNumber
      isActive
      contentType
      additionMethod
      sortMode
      sortField
      sortDirection
      usageWindowDays
      typeFilter
      limit
      shuffleResults
      maxPerCategory
      createdAt
      updatedAt
      items {
        id
        sortOrder
        categoryId
        toolId
        category {
          id
          name
          tools {
            id
            name
            bannerUrl
          }
        }
        tool {
          id
          name
          bannerUrl
        }
      }
    }
  }
`;

export const getAdminTabContent = gql`
  query GetAdminTabContent($tabId: String!) {
    getAdminTabContent(tabId: $tabId) {
      categories {
        id
        name
        tools {
          id
          name
          bannerUrl
        }
      }
      tools {
        id
        name
        bannerUrl
      }
    }
  }
`;

export const getAdminSearchSuggestions = gql`
  query GetAdminSearchSuggestions {
    getAdminSearchSuggestions {
      id
      term
      rowNumber
      isActive
    }
  }
`;

export const searchTools = gql`
  query SearchTools($query: String!, $limit: Int, $simulateReviewMode: Boolean) {
    searchTools(query: $query, limit: $limit, simulateReviewMode: $simulateReviewMode) {
      id
      name
      bannerUrl
      type
      keywords
      isFeatured
      category {
        id
        name
      }
    }
  }
`;
